import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';

import ColorEditor from '../../controls/ColorEditor/ColorEditor';
import BorderControl from '../../controls/BorderControl/BorderControl';
import ShadowControl from '../../controls/ShadowControl/ShadowControl';
import RotationControl from '../../controls/RotationControl/RotationControl';
import PositionSizeScaleControl from '../../controls/PositionSizeControl/PositionSizeScaleControl';
import PositioningControl from '../../controls/PositioningControl/PositioningControl';
import CornerControl from '../../controls/BackgroundBorderControl/CornerControl';
import { refreshTransform } from '../PropertiesHelper';
import usePropertiesStore from '../../../stores/usePropertiesStore';

import globalStyles from '../../GlobalGraphicEditor.module.css';

const { Text } = Typography;

export default function () {
  const group = usePropertiesStore((s) => s.selectedGroup);
  const refreshToggle = usePropertiesStore((s) => s.propertiesRefreshTrigger);
  const onPropertyChanged = usePropertiesStore((s) => s.propertyChanged);

  const shape = group?.findOne('.background');
  const [layoutPositioning, setLayoutPositioning] = useState();
  const [refreshSizeToggle, setRefreshSizeToggle] = useState();

  useEffect(() => {
    updateRefreshSizeToggle();
  }, [refreshToggle]);

  const propertyChanged = () => {
    refreshTransform(group);
    if (onPropertyChanged) {
      onPropertyChanged();
    }
  };

  const updateRefreshSizeToggle = () => {
    setRefreshSizeToggle((refreshSizeToggle) => !refreshSizeToggle);
  };

  const rotationChanged = () => {
    updateRefreshSizeToggle();
    propertyChanged();
  };

  return (
    <div>
      <div
        className={`${globalStyles.bottomBorderDivider} ${globalStyles.bottomBigPaddings}  ${globalStyles.selectBlock} ${globalStyles.bigGapBlock}`}
      >
        <PositionSizeScaleControl
          element={shape}
          group={group}
          layoutPositioning={layoutPositioning}
          refreshToggle={refreshSizeToggle}
          onPropertyChanged={propertyChanged}
        />
        <PositioningControl
          setLayoutPositioning={setLayoutPositioning}
        />
      </div>
      <div className={globalStyles.selectBlock}>
        <div className={globalStyles.bottomBorderDivider}>
          <div
            className={` ${globalStyles.spaceBetweenBlock} ${globalStyles.openBlock}`}
          >
            <Text className={globalStyles.text}>Background colour:</Text>
            <ColorEditor element={shape} onPropertyChanged={propertyChanged} />
          </div>
        </div>
        <div className={globalStyles.bottomBorderDivider}>
          <CornerControl element={shape} onPropertyChanged={propertyChanged} />
        </div>
        <div className={globalStyles.bottomBorderDivider}>
          <BorderControl element={shape} onPropertyChanged={propertyChanged} />
        </div>
        <div className={globalStyles.bottomBorderDivider}>
          <ShadowControl element={shape} onPropertyChanged={propertyChanged} />
        </div>
        <div className={globalStyles.bottomBorderDivider}>
          <RotationControl
            group={group}
            element={shape}
            refreshToggle={refreshToggle}
            onPropertyChanged={rotationChanged}
          />
        </div>
      </div>
    </div>
  );
}
